import { render, staticRenderFns } from "./BlackbodySpectrumViz.vue?vue&type=template&id=2d3a9842&scoped=true"
import script from "./BlackbodySpectrumViz.vue?vue&type=script&lang=js"
export * from "./BlackbodySpectrumViz.vue?vue&type=script&lang=js"
import style0 from "./BlackbodySpectrumViz.vue?vue&type=style&index=0&id=2d3a9842&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3a9842",
  null
  
)

export default component.exports